<template>
    <console-content max-width="1280px">
        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">로그</v-col>
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn class="mr-1" color="secondary" rounded @click="showSearch = !showSearch">
                    <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터
                </v-btn>
            </v-col>
        </v-row>
        
        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mt-3 mx-1">
                <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" sm="3" class="py-0">
                            <v-datetime-field v-model="filter.createdAt[0]" label="검색일자" placeholder=" " hide-details clearable></v-datetime-field>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-datetime-field v-model="filter.createdAt[1]" label="검색일자" placeholder=" " hide-details clearable></v-datetime-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" placeholder=" " hide-details @input="filter.searchValue = null;"/>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-text-field v-model="filter.searchValue" label="검색어" placeholder=" " hide-details :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="page = 1; search(true);">
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>
        
        <v-row class="mt-6 px-1">
            <v-col cols="auto" class="py-0"></v-col>
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <v-btn color="white" class="green--text px-2 ml-1" @click="excel">
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>엑셀다운로드
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table :items="logs" :headers="logsHeaders" :items-per-page="limit" hide-default-footer disable-sort class="mt-3 mx-1 elevation-1">
            <template v-slot:item.createdAt="{item}">
                {{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}
            </template>
            <template v-slot:item.name="{item}">
				{{ item.name || workers.find(worker => worker.phone == item.phone).name || "-" }}
            </template>
            <template v-slot:item.memo="{item}">
                <v-text-field v-model="item.memo" outlined hide-details dense clearable append-icon="save" @click:append="save(item)" />
            </template>
        </v-data-table>

        <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)" />
    </console-content>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import VDatetimeField from "@/components/plugins/vuetify/v-datetime-field.vue";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
		VDatetimeField,
        ConsoleContent,
        VDateField
    },
    data(){
        return {
            mdiMicrosoftExcel,
            show: false,
            loading: true,
            showSearch: true,

            filter: {
				createdAt: [this.$route.query.createdAt?.[0] || `${this.$dayjs().format("YYYY-MM-DD")} 00:00:00`, this.$route.query.createdAt?.[1] || `${this.$dayjs().format("YYYY-MM-DD")} 23:59:59`],
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "연락처", value: "phone" },
            ],

            page: 1,
            pageCount: 0,
            limit: 20,

            excelLimit: 0,

            logs: [],
            logsHeaders: [
				// { text: "type", value: "type", align: "center", /* width: 10 */ },
                { text: "이름", value: "name", align: "center", /* width: 10 */ },
                { text: "연락처", value: "phone", align: "center", /* width: 10 */ },
                { text: "비고", value: "remark", align: "center", /* width: 10 */ },
                { text: "메모", value: "memo", align: "center", /* width: 10 */ },
                { text: "날짜", value: "createdAt", align: "center", /* width: 10 */ },
            ],

			workers: [
                { name: "서순명", phone: "01048773837" },
                { name: "남지영", phone: "01056078657" },
                { name: "조용준", phone: "01051921901" },
                { name: "전채연", phone: "01056240212" },
                { name: "박현수", phone: "01094989473" },
                { name: "우상덕", phone: "01046004701" },
                { name: "박기란", phone: "01056289901" },
                { name: "채선영", phone: "01064797533" },
                { name: "유기찬", phone: "01030990119" },
                { name: "이혜정", phone: "01033820100" },
                { name: "송지영", phone: "01089014068" },
                { name: "김철호", phone: "01024602584" },
            ],
        }
    },
    async mounted(){
        await this.init();
    },
    methods: {
        async init(){
            await this.search();
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, logs } = await api.console.logs.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.logs = logs;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

		async save(log){
            if(confirm("메모를 저장하시겠습니까?")){
                await api.console.logs.put(log);
            }
        },

        async excel(){
            let { logs } = await api.console.logs.gets({ headers: { limit: 0 }, params: this.filter });

            let rows = [];
            logs.forEach(log => {
                rows.push({
                    "type": log.type,
                    "이름": this.workers.find(worker => worker.phone == log.phone)?.name || "-",
                    "연락처": log.phone,
                    "비고": log.remark,
                    "날짜": this.$dayjs(log.createdAt).format("YYYY-MM-DD HH:mm:ss")
                });
            });

            let workbook = new XLSX.utils.book_new();
            let worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "로그");
            XLSX.writeFile(workbook, "로그.xlsx");
        }
    }
}
</script>